// Full-page style loading state for report generation. Matches the sibling
// Business Resilience app's visual language: brand logo inside a spinning
// gradient ring, hero-style headline, and a concise progress caption.
//
// Used on the Report page while `status === "generating"` so the user has
// a proper "something is happening" experience instead of a colour-change
// button.
export default function ReportLoadingState({
    title = "Preparing your executive report…",
    caption = "Just a moment while we pull evidence, references, and analysis together. Typical time: 90–180 seconds.",
}) {
    return (
        <div
            className="mt-10 border border-[#2a2a2a] bg-[#141414] p-10 md:p-16 text-center fade-up flex flex-col items-center"
            data-testid="report-loading-state"
        >
            {/* SPINNING RING + LOGO */}
            <div className="relative w-32 h-32 sm:w-40 sm:h-40 mb-8" aria-hidden>
                <div className="absolute inset-0 report-loading-ring rounded-full" />
                <div className="absolute inset-3 rounded-full border-2 border-[#2a2a2a] bg-[#0a0a0a] flex items-center justify-center overflow-hidden">
                    <img
                        src="/smartnote2self-logo.png"
                        alt=""
                        className="w-14 h-14 sm:w-16 sm:h-16 rounded-sm"
                    />
                </div>
            </div>

            <h2
                className="font-display text-2xl md:text-3xl tracking-tight text-white max-w-lg"
                data-testid="report-loading-title"
            >
                {title}
            </h2>
            <p
                className="mt-3 text-sm md:text-base text-[#c2c2c2] max-w-md leading-relaxed"
                data-testid="report-loading-caption"
            >
                {caption}
            </p>
            <div
                className="mt-8 flex items-center gap-2 text-[11px] uppercase tracking-widest text-[#7a7a7a]"
                aria-live="polite"
            >
                <span className="w-1.5 h-1.5 bg-[#2ec5b6] rounded-full animate-pulse" />
                Working
            </div>
        </div>
    );
}
